export default "__VITE_PUBLIC_ASSET__20367577__"